import { URL } from '../../environments/environment';

export type CountryCode = 'CL' | 'CO' | 'PE' | 'MX' | 'AR';
export type RackeoLocaleId = 'es-CL' | 'es-CO' | 'es-PE' | 'es-MX' | 'es-AR';

export interface RackeoCountryOption {
  code: CountryCode;
  localeId: RackeoLocaleId;
  label: string;
  symbol: string;
  flag: string;
  baseUrl: string;
}

interface RackeoSiteConfig {
  countryCode: CountryCode;
  localeId: RackeoLocaleId;
  ogLocale: string;
  contentSuffix: string;
  countryName: string;
  baseUrl: string;
  paymentBaseUrl: string;
  domainRegisterUrl: string;
}

export interface RackeoSiteView extends RackeoSiteConfig {
  isChile: boolean;
  ogImageUrl: string;
  paymentOgImageUrl: string;
}

export const RACKEO_COUNTRIES: RackeoCountryOption[] = [
  { code: 'CL', localeId: 'es-CL', label: 'Chile', symbol: 'CLP', flag: 'assets/images/rackeo/paises/cl.png', baseUrl: 'https://www.rackeo.cl' },
  { code: 'CO', localeId: 'es-CO', label: 'Colombia', symbol: 'COP', flag: 'assets/images/rackeo/paises/co.png', baseUrl: 'https://www.rackeo.co' },
  { code: 'PE', localeId: 'es-PE', label: 'Perú', symbol: 'PEN', flag: 'assets/images/rackeo/paises/pe.png', baseUrl: 'https://www.rackeo.pe' },
  { code: 'MX', localeId: 'es-MX', label: 'México', symbol: 'MXN', flag: 'assets/images/rackeo/paises/mx.png', baseUrl: 'https://www.rackeo.mx' },
  { code: 'AR', localeId: 'es-AR', label: 'Argentina', symbol: 'ARS', flag: 'assets/images/rackeo/paises/ar.png', baseUrl: 'https://www.rackeo.com.ar' }
];

const BUILD_TLD = 'ar' as 'cl' | 'co' | 'pe' | 'mx' | 'ar';

const DOMAIN_CURRENCY: Record<CountryCode, number> = {
  CL: 1, CO: 6, PE: 3, MX: 8, AR: 4
};

const DOMAIN_TLD: Record<CountryCode, string> = {
  CL: '.cl', CO: '.co', PE: '.pe', MX: '.mx', AR: '.com.ar'
};

const COUNTRY_NAME: Record<CountryCode, string> = {
  CL: 'Chile', CO: 'Colombia', PE: 'Perú', MX: 'México', AR: 'Argentina'
};

const countryCode = BUILD_TLD.toUpperCase() as CountryCode;

const baseSite: RackeoSiteConfig = {
  countryCode,
  localeId: URL.RACKEO_LOCALE as RackeoLocaleId,
  ogLocale: URL.RACKEO_OG_LOCALE,
  contentSuffix: BUILD_TLD,
  countryName: COUNTRY_NAME[countryCode],
  baseUrl: URL.RACKEO_WEBSITE,
  paymentBaseUrl: URL.RACKEO_PAYMENT_WEBSITE,
  domainRegisterUrl: `${URL.RACKEO_CART}?a=add&domain=register&currency=${DOMAIN_CURRENCY[countryCode]}&tld=${DOMAIN_TLD[countryCode]}`
};

export const RACKEO_SITE: RackeoSiteView = {
  ...baseSite,
  isChile: baseSite.countryCode === 'CL',
  ogImageUrl: `${baseSite.baseUrl.replace(/\/$/, '')}/assets/img/og/og_rackeo.png`,
  paymentOgImageUrl: `${baseSite.paymentBaseUrl.replace(/\/$/, '')}/assets/img/og/og_rackeo.png`
};

export function getRackeoCountryUrl(code: CountryCode): string {
  const match = RACKEO_COUNTRIES.find((country) => country.code === code);
  return match ? `${match.baseUrl}/` : '/';
}
